<script>

    import { toast } from 'bulma-toast'
    import { modalStore, configStore } from '../stores'

    import LocationsService from '../$services/locations.service'
    import PackagesService from '../$services/packages.service'

    import LocationSelectComponent from '../locations/component.select.svelte'
    import PackageSelectComponent from '../packages/component.select.svelte'
    import QuotationsComponent from '../quotations/component.quotations.svelte'
    import ShipmentConfirmComponent from './component.shipment.create.svelte'
    import Spinner from '../$components/spinner.svelte'

    $: pickup.sendEmail = $configStore && $configStore.email? $configStore.email.sendPickup : false
    $: delivery.sendEmail = $configStore && $configStore.email? $configStore.email.sendDelivery : false

    export let order = {}
    export let store = {}
    export let isDefault = false

    let loading = false
    let step = 'pickup'

    let pickup = order.pickup || {}
    let delivery = order.delivery
    let ipackage = order.package
    let quotation = null

    if(isDefault)
        setDefaultData()

    async function setDefaultData() {

        loading = true
        let resp = await LocationsService.getLocationDefault()

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        pickup = resp.data || {}

        resp = await PackagesService.getPackageDefault()
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        ipackage = resp.data || {}
        step = 'quotations'
    }


    function onPickupSelected() {
        step = 'delivery'
    }

    function onDeliverySelected() {
        step = 'package'
    }

    function onPackageSelected() {
        step = 'quotations'
    }

    function onQuotationSelected() {
        step = 'guide'
    }

    function onCancel() {
        step = 'pickup'
        modalStore.set('order_modal')
    }

    function setStep(event) {
        step = event.detail || event
    }

</script>

<style>
    @media screen and (max-width: 768px) {
        .steps {
            display: none !important;
        }
    }
</style>

<Spinner {loading} />

{#if !loading}
    <ul class="steps is-small has-content-centered">
        <li class="steps-segment" class:is-active={step === 'pickup'}>
            <span class="steps-marker"></span>
            <div class="steps-content">
                <div class="title">Origen</div>
            </div>
        </li>
        <li class="steps-segment" class:is-active={step === 'delivery'}>
            <span class="steps-marker"></span>
            <div class="steps-content">
                <div class="title">Destino</div>
            </div>
        </li>
        <li class="steps-segment" class:is-active={step === 'package'}>
            <span class="steps-marker"></span>
            <div class="steps-content">
                <div class="title">Paquete</div>
            </div>
        </li>
        <li class="steps-segment" class:is-active={step === 'quotations'}>
            <span class="steps-marker"></span>
            <div class="steps-content">
                <div class="title">Precio</div>
            </div>
        </li>
        <li class="steps-segment" class:is-active={step === 'guide'}>
            <span class="steps-marker"></span>
            <div class="steps-content">
                <div class="title">Guía</div>
            </div>
        </li>
    </ul>

    {#if step === 'pickup'}
        <LocationSelectComponent bind:location={pickup} on:selected={onPickupSelected} on:cancel={onCancel} />
    {/if}
    {#if step === 'delivery'}
        <LocationSelectComponent bind:location={delivery} on:selected={onDeliverySelected} on:cancel={onCancel} showSelected={false} showReturn={true} on:return={() => setStep('pickup')} />
    {/if}
    {#if step === 'package'}
        <PackageSelectComponent bind:ipackage={ipackage} on:selected={onPackageSelected} on:cancel={onCancel} showReturn={true} on:return={() => setStep('delivery')} />
    {/if}
    {#if step === 'quotations'}
        <QuotationsComponent {pickup} {delivery} {ipackage} bind:quotation={quotation}  on:selected={onQuotationSelected} showReturn={true} on:return={() => setStep('package')} />
    {/if}
    {#if step === 'guide'}
        <ShipmentConfirmComponent {store} {order} {pickup} {delivery} {ipackage} {quotation} on:step={setStep} showReturn={true} on:return={() => setStep('quotations')} />
    {/if}
{/if}
